import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { IFinantialReport } from '../interfaces/finantial-report/ifinantial-report';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { param } from 'cypress/types/jquery';

@Injectable({
  providedIn: 'root'
})
export class FinantialReportService {
  url: string = environment.url;


  constructor(private http: HttpClient,private datePipe: DatePipe) { }
  /*
  get(year: any,unit: any) {
    return this.http
      .get(this.url + `/report/financial?year=${year}&unit=${unit}&filterType=year`)
      .pipe(map((res: any) => res)) as Observable<any>;
    //.pipe(map((res: any) => res['hydra:member'])) as Observable<IEmployeeReport>;
  }
  */
  get(p: string) {
    let params = [
      {field: 'year',value: this.datePipe.transform(new Date(),'yyyy')},
      {field: 'unit[]',value: this.unitId}
    ];
    p = this.defaultParams(params,p);

    return this.http
      .get(this.url + `/report/financial${p}`)
      .pipe(map((res: any) => res)) as Observable<any>;
    //.pipe(map((res: any) => res['hydra:member'])) as Observable<IEmployeeReport>;
  }

  getResult(filter: string) {
    return this.http
    .get(this.url + `/graph/monthly/adjusted/performance/comparative${filter}`)
    .pipe(map((res: any) => res['hydra:member'])) as Observable<any>;
  }

  getResultServiceByCategory(filter: string) {
    return this.http
    .get(this.url + `/graph/monthly/unit/revenue/by/category${filter}`)
    .pipe(map((res: any) => res['hydra:member'])) as Observable<any>;
  }

  getResultRevenueAnual(filter: string = '') {
    return this.http
    .get(this.url + `/anual/profit${filter}`)
    .pipe(map((res: any) => res['hydra:member'])) as Observable<any>;
  }

  getResultMonthToReal(filter: string) {
    return this.http
    .get(this.url + `/graph/monthly/real/performance/comparative${filter}`)
    .pipe(map((res: any) => res['hydra:member'])) as Observable<any>;
  }

  getResultExams(p: string, csv?: boolean, options?: any) {
    let params = [
      {field: 'year',value: this.datePipe.transform(new Date(),'yyyy')},
      {field: 'unit[]',value: this.unitId}
    ];

    if(csv) {
      params.push({field: 'csv',value: 'true'})
    }

    p = this.defaultParams(params,p);

    return this.http
      .get(this.url + `/monthly-amounts${p}`,options)
      .pipe(map((res: any) => res)) as Observable<any>;
  }

  getResultMonthlyFinantial(p: string, csv?: boolean, options?: any) {
    let params = [
      {field: 'year',value: this.datePipe.transform(new Date(),'yyyy')},
      {field: 'unit[]',value: this.unitId}
    ];

    if(csv) {
      params.push({field: 'csv',value: 'true'})
    }

    p = this.defaultParams(params,p);

    return this.http
    .get(this.url + `/monthly-financial-movement${p}`,options)
    .pipe(map((res: any) => res)) as Observable<any>;
  }

  getResultAnnual(p: string,csv?: boolean, options?: any) {
    let params = [
       {field: 'unit[]',value: String(this.unitId)}
    ];

    if(csv) {
      params.push({field: 'csv',value: 'true'})
    }

    p = this.defaultParams(params,p);
    return this.http
    .get(this.url + `/annual-results-financial${p}`,options)
    .pipe(map((res: any) => res)) as Observable<any>;
  }

  getRevenueExpenseByYear(p : string) {
    let params = [
      {field: 'year',value: this.datePipe.transform(new Date(),'yyyy')},
      {field: 'unit[]',value: this.unitId}
    ];
    p = this.defaultParams(params,p);

    return this.http
    .get(this.url + `/revenue-expense-by-year${p}`)
    .pipe(map((res: any) => res)) as Observable<any>;
  }

  getRevenueExpensePrevious(p : string) {
    let params = [
      {field: 'year',value: this.datePipe.transform(new Date(),'yyyy')},
      {field: 'unit[]',value: this.unitId}
    ];
    p = this.defaultParams(params,p);

    return this.http
    .get(this.url + `/revenue-expense-last-month${p}`)
    .pipe(map((res: any) => res)) as Observable<any>;
  }

  get unitId() :number {
    return Number(window.localStorage.getItem('unitId'));
  }

  defaultParams(defaultParams: {field: any, value: any} [], p : string) : string {
    defaultParams.forEach(({field, value}) => {
      if(!p.includes(field)) {
        p += `${p != '' ? '&' : ''}${field}=${value}`;
      }
    });
    if(!p.includes('?')) {
      p = `?${p}`;
    }
    return p;
  }
}
